import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

/**
 * Modal menu untuk navigasi di mobile
 * @param {boolean} isOpen - Status modal terbuka/tertutup
 * @param {function} onClose - Callback saat modal ditutup
 * @param {string} title - Judul modal
 * @param {Object[]} items - Array menu items
 * @param {function} onSelect - Callback saat item dipilih
 * @param {boolean} isDarkMode - Status dark mode
 * @param {string} activeMenu - ID menu yang aktif
 */
const MobileMenuModal = ({ isOpen, onClose, title, items, onSelect, isDarkMode, activeMenu }) => {
    if (!isOpen) return null;

    return createPortal(
        <div
            className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm flex items-end justify-center"
            onClick={onClose}
        >
            <div
                className={`w-full rounded-t-2xl p-6 animate-slide-up shadow-[0_-4px_20px_-5px_rgba(0,0,0,0.1)] relative ${isDarkMode ? 'bg-slate-900 text-slate-100' : 'bg-white text-slate-800'}`}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <h3 className="font-semibold text-base">{title}</h3>
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); onClose(); }}
                        className={`p-2 -mr-2 rounded-full transition-colors relative z-50 cursor-pointer ${isDarkMode ? 'hover:bg-slate-800' : 'hover:bg-slate-100'}`}
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Menu Grid */}
                <div className="grid grid-cols-4 gap-4">
                    {items.map((item) => {
                        const isActive = activeMenu === item.id;
                        return (
                            <button
                                key={item.id}
                                onClick={() => onSelect(item)}
                                className="flex flex-col items-center gap-2 group"
                            >
                                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center transition-all ${isActive
                                    ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-500/30'
                                    : (isDarkMode ? 'bg-slate-800 text-slate-400 hover:bg-slate-700' : 'bg-slate-100 text-slate-600 hover:bg-slate-200')
                                    }`}>
                                    <item.icon size={20} strokeWidth={1.5} />
                                </div>
                                <span className={`text-[10px] text-center leading-tight ${isActive ? 'font-medium text-indigo-500' : 'text-slate-500'}`}>
                                    {item.label}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default MobileMenuModal;
